
  var _styles = {
  "vertical-double-card": {
    "width": "4.56rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "vertical-double-card__header-img-wrapper": {
    "width": "100%",
    "height": "2.66667rem"
  },
  "vertical-double-card__header-img": {
    "width": "4.56rem",
    "height": "2.66667rem"
  },
  "vertical-double-card__goods-info-wrapper": {
    "width": "100%",
    "padding": "0.21333rem"
  },
  "vertical-double-card__goods-name": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)"
  },
  "vertical-double-card__merchant-name": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "fontWeight": "400"
  },
  "vertical-double-card__price-info-wrapper": {
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "vertical-double-card__sell-price": {
    "fontSize": "16px",
    "fontWeight": "500",
    "color": "rgb(17,25,37)"
  },
  "vertical-double-card__origin-price": {
    "fontSize": "12px",
    "fontWeight": "400",
    "color": "rgb(100,105,113)",
    "textDecoration": "line-through"
  }
};



  module.exports = _styles;
  